import { useState } from 'react';
import './App.css';
import Picker from 'react-mobile-picker';

const selections = {
  hour: [
    '00', '01', '02', '03', '04', '05', '06', '07', '08', '09',
    '10', '11', '12', '13', '14', '15', '16', '17', '18', '19',
    '20', '21', '22', '23',
  ],
  minute: [
    '00', '01', '02', '03', '04', '05', '06', '07', '08', '09',
    '10', '11', '12', '13', '14', '15', '16', '17', '18', '19',
    '20', '21', '22', '23', '24', '25', '26', '27', '28', '29',
    '30', '31', '32', '33', '34', '35', '36', '37', '38', '39',
    '40', '41', '42', '43', '44', '45', '46', '47', '48', '49',
    '50', '51', '52', '53', '54', '55', '56', '57', '58', '59',
  ],
};

function App() {
  const [pickerValue, setPickerValue] = useState({
    hour: '00',
    minute: '00',
  });

  const handleOkClick = () => {
    const selectedHour = pickerValue.hour;
    const selectedMinute = pickerValue.minute;

    // Guarda os valores selecionados na sessão
    sessionStorage.setItem('selectedHour', selectedHour);
    sessionStorage.setItem('selectedMinute', selectedMinute);

    // Redireciona para a página de destino
    window.location.href = 'https://olare.app/demo/index.php/guardar-alarmes/';
  };

  return (
    <div className="App">
      <header className="App-header">
        <div className="timediv">
          <Picker
            value={pickerValue}
            onChange={setPickerValue}
            wheelMode="natural"
            itemHeight={60}
            height={400}
          >
            {Object.keys(selections).map((name) => (
              <Picker.Column key={name} name={name}>
                {selections[name].map((option) => (
                  <Picker.Item key={option} value={option}>
                    <div className={`timepicker ${pickerValue[name] === option ? 'selected' : ''}`}>
                      {option}
                    </div>
                  </Picker.Item>
                ))}
              </Picker.Column>
            ))}
          </Picker>
          <div id="okbotao" onClick={handleOkClick}>
            <p className="okbotao">OK</p>
          </div>
        </div>
      </header>
    </div>
  );
}

export default App;


